import React, { useEffect } from "react";
import "./Add_Points_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Modal_Heading/Modal_Heading";
import Add_Points_Modal_Frame from "./Add_Points_Modal_Frame/Add_Points_Modal_Frame";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { AddRemovePoints } from "../../../../utils/apis/wallet_management/wallet_hisory/wallet_history";

function Add_Points_Modal(props) {
  const id = props.show;

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("amount", data?.amount);
      DataToSend.append("type", "Credit");
      const response = await AddRemovePoints(id, DataToSend);
      console.log(response);

      if (response?.data?.success) {
        await props?.setShowModal({
          code: response?.data?.code,
          message: response?.data?.data,
        });
        reset();
        props.getDataAll();
        setTimeout(() => {
          props?.setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        // await setShowModal({ code: response.code, message: response.message });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <section>
        <Modal
          {...props}
          className=" Add_Points_Modal modal_holder"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={"Add Points"} />
          <div className="modal-body-holder">
            <Modal.Body>
              <div className="main-form-holder">
                <Form onSubmit={handleSubmit(onSubmit)} className="form-holder">
                  <div className="row">
                    <div className="col-md-12">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Payment</Form.Label>
                        <Form.Control
                          type="text"
                          name="amount"
                          placeholder="Amount"
                          className={classNames("", {
                            "is-invalid": errors?.amount,
                          })}
                          {...register("amount", {
                            required: "Amount is required",
                          })}
                          onKeyDown={(e) => {
                            if (
                              [
                                "Backspace",
                                "Tab",
                                "ArrowLeft",
                                "ArrowRight",
                                "Delete",
                              ].includes(e.key)
                            ) {
                              return;
                            }
                            if (
                              (e.key >= "0" && e.key <= "9") ||
                              (e.key === "." && !e.target.value.includes("."))
                            ) {
                              return;
                            }
                            e.preventDefault();
                          }}
                        />

                        {errors.amount && (
                          <span className="text-danger">
                            {errors.amount.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button className="search-btn" onClick={props.onHide}>
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
      </section>
    </>
  );
}

export default Add_Points_Modal;
